import { Brand } from '@awaze/design-system.components.awaze-theme-provider'
import { AutoCompleteResult } from '@awaze/design-system.components.autocomplete'
import getConfig from 'next/config'
import { getUrlForEnv } from './SearchForm.helper'
import { locationLookupClient } from '@awaze/mfe-common.api.location-lookup-client'

export const getAutoSuggestSearch = (brand: Brand, marketCode: string) => {
  const { publicRuntimeConfig } = getConfig()
  const environment = publicRuntimeConfig.APP_ENV

  return async (
    searchTerm: string,
    accommodationType: string,
    propertiesOnly: boolean,
  ): Promise<AutoCompleteResult[]> => {
    const locationResult = await locationLookupClient(searchTerm, {
      brand: brand,
      language: marketCode,
      accommodationType: accommodationType,
      maxAutocompleteResults: 100,
      auth: {
        LOCATION_API_URL: getUrlForEnv(environment),
        LOCATION_API_KEY: publicRuntimeConfig[environment]?.LOCATION_API_KEY,
      },
    })

    interface Property {
      id: string
      link: string
      title: string
      location: string
    }

    const mapPropertyToAutocomplete = (p: Property): AutoCompleteResult => ({
      id: p.id,
      link: p.link,
      name: p.title,
      subtitle: [p.id, p.location].join(', ').replace(/,\s*$/, ''),
      property: true,
    })

    return propertiesOnly
      ? locationResult
          .flatMap((p) =>
            p.property && 'property' in p && 'title' in p ? [p] : [],
          )
          .map((p) => mapPropertyToAutocomplete(p))
      : locationResult.map((l) =>
          l.property && 'property' in l && 'title' in l
            ? mapPropertyToAutocomplete(l)
            : (l as AutoCompleteResult),
        )
  }
}
